var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPencilOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil-line 2",
    clipPath: "url(#clip0_2706_8197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19438 4.40145L0.792969 8.80291V11.092V13.3811H3.09167H5.39038L9.79179 8.97967L14.1932 4.57822L11.9041 2.28911C10.645 1.0301 9.61059 0 9.60536 0C9.6001 0 7.61516 1.98065 5.19438 4.40145ZM5.79653 5.50062L1.99727 9.29992V10.7479V12.1959H3.43563H4.87398L8.68296 8.38715L12.4919 4.57837L11.0535 3.13984C10.2624 2.34865 9.61071 1.70131 9.60543 1.70131C9.60014 1.70131 7.88613 3.411 5.79653 5.50062ZM0.831201 15.3978V16H8.01878H15.2064V15.3978V14.7957H8.01878H0.831201V15.3978Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2706_8197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencilOutline);
export default __webpack_public_path__ + "static/media/icon--pencil-outline.ab8905b27fccf5ab7fe301f156120382.svg";
export { ForwardRef as ReactComponent };